import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFilter } from "@result/rui/utils/api";

import ApiClient from "#/redux/api/ApiClient";
import { handleLoadingAndErrorState } from "#/redux/util/reduxUtils";
import { getErrorMessage } from "#/utils/APIUtils";

export const fetchLactationPeriodsForMilkControlPage = createAsyncThunk(
  "lactationCalculationsByMilkControl/fetchByZivalId",
  async (
    { zivalId, page = { page: 0, size: 100 }, sort },
    { rejectWithValue }
  ) => {
    if (!zivalId) {
      throw new Error("zivalId is required");
    }

    const filter = new ApiFilter().equal("zivalId", zivalId);
    try {
      const response = await ApiClient.get(
        "/api/zival/vwsamicemlecnost/page",
        undefined,
        page,
        filter,
        sort
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const thunks = [fetchLactationPeriodsForMilkControlPage];

const lactationCalculationsByMilkControlSlice = createSlice({
  name: "lactationCalculationsByMilkControl",
  initialState: {
    page: {
      content: [],
      number: 0,
      totalElements: 0,
      totalPages: 0,
      size: 0,
    },
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchLactationPeriodsForMilkControlPage.fulfilled,
      (state, action) => {
        state.page = action.payload;
      }
    );
    handleLoadingAndErrorState(builder, thunks);
  },
});

export default lactationCalculationsByMilkControlSlice.reducer;
